<template>
  <h2>Member Referrals</h2>
</template>

<script>
export default {}
</script>
